/**
 * Defer Load
 */
function insertScripts(scripts, opt = {}) {
  scripts.forEach(scriptItem => {
    let append_flag = true;
    if (!window.location.href.includes('vego-garden-s-soil-cost-calculator') && scriptItem.includes('soil-calculator')) append_flag = false
    if (!window.location.href.includes('the-perfect-time-to-plant') && scriptItem.includes('time-to-plant')) append_flag = false
    if (!opt.need_subscription && scriptItem.includes('subscription')) append_flag = false
    if (!window.location.href.includes('giving-back') && !window.location.href.includes('school-gardens') && scriptItem.includes('giving-back')) append_flag = false
    if (!window.location.href.includes('help-me-choose') && scriptItem.includes('help-me-choose')) append_flag = false
    if (!window.location.href.includes('/products/') && scriptItem.includes('vego-recent-viewed')) append_flag = false
    if (!window.location.href.includes('/products/vego-garden-gift-card') && scriptItem.includes('calendar')) append_flag = false
    if (scriptItem && append_flag && !document.querySelector(`script[src="${scriptItem}"]`)) {
      let el = document.createElement('script')
      el.type = "text/javascript"
      el.src = scriptItem
      document.head.append(el)
    }
  })
}
function initPage() {
  let thread_time = 5000
  let path_name = window.location.pathname
  let need_subscription = [`carbon-refill-kit`, `kitchen-composter`, `vegotabs`, `carbon-filter-refill-kit-vegotab-bundle`,`carbon-filter-refill-kit-vegotabs-bundle-copy`].find(item => window.location.href.includes(item))

  if (path_name != '/' && !path_name.includes('/products') && !path_name.includes('/collections')) thread_time = 500
  if (need_subscription) thread_time = 500
  if (path_name.includes('/help-me-choose')) thread_time = 500
  if (path_name.includes('/search')) thread_time = 800
  //console.log(`defer load thread_time----- ${thread_time}`)
  let speedScripts = []
  let scripts = document.querySelector('.home-scripts').getAttribute('data-scripts').split(',')
  let mobile_scripts = document.querySelector('.home-scripts').getAttribute('data-m-scripts').split(',')
  // scripts = [`vego-banner-term`]
  let scripts_tmp = []
  speedScripts = scripts.filter(script => {
    let is_in = [`vego-banner-term`].find(item => script.indexOf(item)>-1)
    if (!is_in) scripts_tmp.push(script)
    return is_in
  })

  scripts = scripts_tmp
  
  setTimeout(() => {
    insertScripts(speedScripts, {})
  },0) // load early than normal script

  setTimeout(() => {
    insertScripts(scripts, { need_subscription })
    if (window.innerWidth < 768) {
      insertScripts(mobile_scripts, { need_subscription })
    }
  }, thread_time)
  if (window.innerWidth < 768) {
    insertScripts(mobile_scripts.filter(item => item.indexOf('vego-mobile-menu') > -1), { need_subscription })
  }
}
//
initPage()

window.addEventListener("load", function () {

  let yotpo_thread = 1500;                  // delay more than 1.5s for mobile
  if (window.innerWidth > 768) yotpo_thread = 0
  setTimeout(() => window.appendScript('https://cdn-widgetsrepository.yotpo.com/v1/loader/GMrPmOwmfbQQyiX96ovnXKEgiM2FIQCtCOEvofCf'), yotpo_thread)

  let klaviyo_thread = 10000;                  // delay more than 10s for mobile
  if (window.innerWidth > 768) klaviyo_thread = 0
  setTimeout(() => window.appendScript('https://static.klaviyo.com/onsite/js/Uw3LDV/klaviyo.js?company_id=Uw3LDV'), klaviyo_thread)

  if(window.location.href.includes('/products/')) {
    const gotolstoy_url = "https://widget.gotolstoy.com/widget/widget.js?app-key=74d145e3-7c70-46d2-8af2-290e3eff51f0\u0026shop=vego-gardening-store.myshopify.com";
    if(document.querySelector(`[src="${gotolstoy_url}"]`))return;
    let rec_thread = 8000;                  // delay more than 8s for mobile
    if (window.innerWidth > 768) rec_thread = 2000
    setTimeout(() => window.appendScript(gotolstoy_url), rec_thread);
    let gotolstoy_subscripe = document.querySelector(".page-product-v2");
    if (
      gotolstoy_subscripe &&
      gotolstoy_subscripe.getAttribute("data-gotolsoy")
    ) {
      setTimeout(() => {
        window.appendScript(gotolstoy_subscripe.getAttribute("data-gotolsoy"));
      }, rec_thread+400);
    }
  }
  const other_urls = [
    "https://d38xvr37kwwhcm.cloudfront.net/js/grin-sdk.js?shop=vego-gardening-store.myshopify.com",
    "//cdn.shopify.com/proxy/b3b943ce714ac1958d6fb81f34c38f94112875110fc8db772c56d0604a3515ae/s3-us-west-2.amazonaws.com/jsstore/a/OO9H4O1/ge.js?shop=vego-gardening-store.myshopify.com\u0026sp-cache-control=cHVibGljLCBtYXgtYWdlPTkwMA",
    "//cdn.shopify.com/proxy/8c42d01f5aac1566b97ba205bf9492ba34f852152beec46d80961f55c7967e01/app.retention.com/shopify/shopify_app_add_to_cart_script.js?shop=vego-gardening-store.myshopify.com\u0026sp-cache-control=cHVibGljLCBtYXgtYWdlPTkwMA",
    "//cdn.shopify.com/proxy/0663f7f32039c7b311053b4d393a8c56d162661327b97086e4f5b282726c8549/s.pandect.es/scripts/pandectes-core.js?shop=vego-gardening-store.myshopify.com\u0026sp-cache-control=cHVibGljLCBtYXgtYWdlPTkwMA",
    "https://cdn.noibu.com/collect-core.js?shop=vego-gardening-store.myshopify.com",
  ];
  let rec_thread_other = 8000; // delay more than 8s for mobile
  if (window.innerWidth > 768) rec_thread_other = 2000;
  setTimeout(() => {
    other_urls.forEach(url=>{
      window.appendScript(url);
    })
  }, rec_thread_other);

})


